


































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
@Component
export default class ECSettingView extends Vue {
  public items: Common.ECSetting[] = new Array(0);
  public params: Common.ECSettingQuery = new Common.ECSettingQuery();

  public sortOptions: any = [
    { value: 'ecFlag', text:'EC連携先' },
  ];

  public created() {
    if (this.$route.query.code && this.$route.query.state){
       //stateパラメータの2つ目をとる
        const ecFlag = Number.parseInt((this.$route.query.state as string).split('|')[1]);
        const seqNo = Number.parseInt((this.$route.query.state as string).split('|')[2]);
        this.$api.execute(new Common.ECAuthorizeQuery(this.$route.query.code as string,ecFlag,seqNo)).then(res => {
          this.$router.push(this.$route.path,()=>{
            this.$api.modal.showDialog('メッセージ','ECサイトでの認証が完了しました。').then(()=>{
              var index = this.items.findIndex(obj=>obj.ecFlag == ecFlag);
              this.$set(this.items, index,res);
              (this.$refs.mainList as Components.ListView).listSelect(index,true);
            });
          });
        });
    }
  }

  public async onCreate(obj: Common.ECSetting) {
    const workflows = this.$api.formatter.getOptions('workflow_approval');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  //暫定実装～リダイレクト先で実装する必要がある
  public onAuthorize(item:Common.ECSetting){
    if (item.ecFlag == Common.ECFlags.Base){
      const url = 'https://api.thebase.in/1/oauth/authorize?response_type=code&client_id={0}&redirect_uri={1}&state={2}&scope=read_items read_orders write_items';
      const client_id = process.env.VUE_APP_BaseClientId;//'3948bff61d960d0e0261e84dc371d861'; 
      var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
      redirect_uri += location.pathname;
      const state = this.$api.license.tenantId + '|' + Common.ECFlags.Base.toString() + '|' + item.seqNo.toString();
      location.href = encodeURI(String.format(url,client_id,redirect_uri,state));
    }

    // this.$api.execute(new Common.ECAuthorizeQuery('7c480ac2e39adb9a68d2b8b46c60f44a',null)).then(res => this.$set(this.items, (this.$refs.mainList as Components.ListView).selectedId(),res));
  }

  public checkSelectedItems():boolean{
    var selectedItems = (this.$refs.mainList as Components.ListView).selectedItems as Array<Common.ECSetting>;
    if (selectedItems == null || selectedItems.length == 0) {
      this.$api.modal.show('無効な操作', '対象となる項目を選択して下さい。', true, null);      
      return false;
    }
    if (selectedItems.filter(obj =>obj.state == Common.ApprovalStatus.NotApproved).length != 0) {
      this.$api.modal.show('無効な操作', '「公開待ち」の項目に対しては処理を実行できません。', true, null);      
      return false;
    }
    if (selectedItems.filter(obj =>obj.hasValidToken == false).length != 0) {
      this.$api.modal.show('無効な操作', '「認証待ち」の項目に対しては処理を実行できません。', true, null);      
      return false;
    }    
    return true;
  }
  public execCommodityQuery(){
    if (this.checkSelectedItems()){
      this.$api.modal.showDialog('メッセージ','商品取込処理を開始してよろしいですか？',false).then(()=>{
        this.$api.execute(new Common.ECCommodityQuery((this.$refs.mainList as Components.ListView).selectedItems)).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','商品取込処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);       
        });
      });
    }
  }

  public execOrderQuery(){
    if (this.checkSelectedItems()){
      this.$api.modal.showDialog('メッセージ','注文取込処理を開始してよろしいですか？',false).then(()=>{
        this.$api.execute(new Common.ECOrderQuery((this.$refs.mainList as Components.ListView).selectedItems)).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','注文取込処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);       
        });
      });
    }
  }
  public execProcessQuery(){
    if (this.checkSelectedItems()){
      this.$api.modal.showDialog('メッセージ','出荷・キャンセル取込処理を開始してよろしいですか？',false).then(()=>{
        this.$api.execute(new Common.ECProcessQuery((this.$refs.mainList as Components.ListView).selectedItems)).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','出荷・キャンセル取込処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);       
        });
      });        
    }    
  }
    public onEcOptionFlagsChanged(item:Common.ECSetting) {
      if(item.ecOptionFlag == Common.ECOptionFlags.Base_UseIdentifier ) item.autoCommodityInsert2 = false;
  }  
}
